import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type GetSalesRequest = {
  token: string;
  structuredNoteId: string;
};

const downloadNoteSales = async ({
  token,
  structuredNoteId,
}: GetSalesRequest) => {
  try {
    const url = `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-repayment/download-structured-note-sales-detail/${structuredNoteId}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
      withCredentials: true,
    });

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadNoteSales;
